import { OptionsRequestContext, OptionsRequestParams } from './types';
import { StoreData, StoreMetadata, StoreField, StoreItemPath } from 'app/types-shared';

export const ACTION = {
  VALUE_CHANGE: 'UI:VALUE_CHANGE',
  BACKGROUND_SAVE: 'UI:BACKGROUND_SAVE',
  BACKGROUND_SAVE_OK: 'UI:BACKGROUND_SAVE_SUCCESS',
  BACKGROUND_SAVE_ERROR: 'UI:BACKGROUND_SAVE_ERROR',
  REQUEST_IMMEDIATE_BACKGROUND_SAVE: 'UI:REQUEST_IMMEDIATE_BACKGROUND_SAVE',
  CASE_SUBMIT: 'UI:CASE_SUBMIT',
  REQUEST_CASE_SUBMIT: 'UI:REQUEST_CASE_SUBMIT',
  CASE_SUBMIT_OK: 'UI:CASE_SUBMIT_OK',
  CASE_SUBMIT_ERROR: 'UI:CASE_SUBMIT_ERROR',
  ITEMS_SAVED: 'UI:ITEMS_SAVED',
  INSPECT_COMPONENT: 'UI:INSPECT_COMPONENT',
  INSPECT_PREVIEW_EDIT: 'UI:INSPECTOR_PREVIEW_EDIT',
  LOAD_OPTIONS_CODES: 'UI:REQUEST_CODETABLE',
  LOAD_OPTIONS_CODES_OK: 'UI:RECEIVE_CODETABLE',
  LOAD_OPTIONS_CODES_ERROR: 'UI:REQUEST_CODETABLE_ERROR',
  LOAD_CATEGORY_CODES: 'UI:REQUEST_CODETABLE_CATEGORY',
  LOAD_CATEGORY_CODES_OK: 'UI:RECEIVE_CODETABLE_CATEGORY',
  LOAD_CATEGORY_CODES_ERROR: 'UI:REQUEST_CODETABLE_CATEGORY_ERROR',
  REQUEST_SAVE_AS_DRAFT: 'UI:BEGIN_SAVE_AS_DRAFT',
  SAVE_AS_DRAFT_COMPLETED: 'UI:SAVE_AS_DRAFT_COMPLETED'
};

export class ValueChange {
  public type: string = ACTION.VALUE_CHANGE;

  constructor(public storePath: StoreItemPath[], public dataTag: string, public value: StoreField[]) {
    this.storePath = storePath;
    this.value = value;
    this.dataTag = dataTag;
  }
}

export class RequestCodetable {
  public type: string = ACTION.LOAD_OPTIONS_CODES;

  constructor(public context: OptionsRequestContext, public loadOptions: OptionsRequestParams) {
    this.loadOptions = loadOptions;
    this.context = context;
  }
}

export class RequestCodetableError {
  public type: string = ACTION.LOAD_OPTIONS_CODES_ERROR;

  constructor(public context: OptionsRequestContext, public loadOptions: OptionsRequestParams) {
    this.context = context;
    this.loadOptions = loadOptions;
  }
}

export class ReceiveCodetable {
  public type: string = ACTION.LOAD_OPTIONS_CODES_OK;

  constructor(public context: OptionsRequestContext, public loadOptions: OptionsRequestParams, public data?: any) {
    this.data = data;
    this.context = context;
    this.loadOptions = loadOptions;
  }
}

export class RequestCodetableCategory {
  public type: string = ACTION.LOAD_CATEGORY_CODES;

  constructor(public context: OptionsRequestContext, public categoryOptions: OptionsRequestParams) {
    this.categoryOptions = categoryOptions;
    this.context = context;
  }
}

export class RequestCodetableCategoryError {
  public type: string = ACTION.LOAD_CATEGORY_CODES_ERROR;

  constructor(public context: OptionsRequestContext, public categoryOptions: OptionsRequestParams) {
    this.context = context;
    this.categoryOptions = categoryOptions;
  }
}

export class ReceiveCodetableCategory {
  public type: string = ACTION.LOAD_CATEGORY_CODES_OK;

  constructor(public context: OptionsRequestContext, public categoryOptions: OptionsRequestParams, public data?: any) {
    this.data = data;
    this.context = context;
    this.categoryOptions = categoryOptions;
  }
}

export class BeginBackgroundSave {
  public type: string = ACTION.BACKGROUND_SAVE;
}

export class BackgroundSaveComplete {
  public type: string = ACTION.BACKGROUND_SAVE_OK;

  constructor(public data: StoreData, public metadata: StoreMetadata, public etag: string) {
    this.data = data;
    this.metadata = metadata;
    this.etag = etag;
  }
}

export class RequestImmediateBackgroundSave {
  public type: string = ACTION.REQUEST_IMMEDIATE_BACKGROUND_SAVE;
}

export class BackgroundSaveFailed {
  public type: string = ACTION.BACKGROUND_SAVE_ERROR;

  constructor(public errors: any) {
    this.errors = errors;
  }
}

export class BeginCaseSave {
  public type: string = ACTION.CASE_SUBMIT;

  constructor(public continueEditing: boolean = false) {
    this.continueEditing = continueEditing;
  }
}

export class RequestCaseSave {
  public type: string = ACTION.REQUEST_CASE_SUBMIT;
}

export class CaseSaveComplete {
  public type: string = ACTION.CASE_SUBMIT_OK;
}

export class CaseSaveFailed {
  public type: string = ACTION.CASE_SUBMIT_ERROR;
}

export class InspectComponent {
  public type: string = ACTION.INSPECT_COMPONENT;

  constructor(public payload: any, public error: any) {
    this.payload = payload;
    this.error = error;
  }
}

export class InspectPreviewEdit {
  public type: string = ACTION.INSPECT_PREVIEW_EDIT;

  constructor(public payload: any) {
    this.payload = payload;
  }
}
export class RequestSaveAsDraft {
  public type: string = ACTION.REQUEST_SAVE_AS_DRAFT;
}

export class SaveAsDraftCompleted {
  public type: string = ACTION.SAVE_AS_DRAFT_COMPLETED;
}
